import React from "react";
import { IErrorMessagePassword } from "models/login";
import * as S from './style';

interface Props {
  show: boolean;
  errorMessage: IErrorMessagePassword;
}

function ErrorInputMessage(props: Props) {
  return props.show ? (
    <S.DivStyled>
      <S.MessageInput>{props.errorMessage}</S.MessageInput>
    </S.DivStyled>
  ) : null
}

export default ErrorInputMessage;